// Angular
import {
  Component,
  inject,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
// Components
import { HeroCarouselInteractiveComponent } from './components/hero-carousel-interactive/hero-carousel-interactive.component';
import { HeroCarouselStaticComponent } from './components/hero-carousel-static/hero-carousel-static.component';
import { HeroCarouselSkeletonComponent } from './components/hero-carousel-skeleton/hero-carousel-skeleton.component';
import { HeroCarouselErrorComponent } from './components/hero-carousel-error/hero-carousel-error.component';
// Services
import { HeroCarouselStateService } from './services/hero-carousel-state.service';
import { HeroCarouselMetaService } from './services/hero-carousel-meta.service';
import { HeroCarouselPreloadService } from './services/hero-carousel-proload.service';
import {
  HERO_CAROUSEL_CONFIG,
  HERO_CAROUSEL_CONFIG_TOKEN,
} from './config/hero-carousel.config';

const COMPONENTS = [
  HeroCarouselInteractiveComponent,
  HeroCarouselStaticComponent,
  HeroCarouselSkeletonComponent,
  HeroCarouselErrorComponent,
];

const SERVICES = [
  HeroCarouselStateService,
  HeroCarouselMetaService,
  HeroCarouselPreloadService,
];

@Component({
  selector: 'app-hero-carousel',
  standalone: true,
  imports: [COMPONENTS],
  providers: [
    SERVICES,
    { provide: HERO_CAROUSEL_CONFIG_TOKEN, useValue: HERO_CAROUSEL_CONFIG },
  ],
  templateUrl: './hero-carousel.component.html',
  styleUrl: './hero-carousel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeroCarouselComponent implements OnInit {
  readonly stateService = inject(HeroCarouselStateService);

  ngOnInit(): void {
    this.stateService.initialize();
  }

  onSlideClick(event: {
    slide: any;
    index: number;
    originalEvent: Event;
  }): void {
    this.stateService.trackSlideClick(
      event.slide,
      event.index,
      event.originalEvent
    );
  }
}
